import React, { Component } from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",];
var date = new Date();

const MainBlock = styled.div`
  height: auto;
  margin-top: 10px;

  .datepicker-div {
    position: relative;
    width: 100%;
    // transform: scale(0.9);

    // margin-left:-22px;
    z-index: 98;
    opacity: 1; //here
  }

  .datePickerSubmitButton {

    border: 0px solid #2c387a;
    border-radius: 6px;
    background: #2c387a;
    color: #fff;
    margin-top: 12px;
  }

  .enabled {
    pointer-events: auto;
    opacity: 1;
  }

  .icon {
    height: 20px;
    width: 20px;
    background: red;
  }
  .sf-datepicker {
    padding: 10px;
    color: #666666;
    font-size: 14px;
    cursor: pointer;
    width: 92%;
    background: white;
    text-align: left !important;
    border: 1px solid #2c387a !important;
    border-radius: 5px !important;
    margin-bottom: 5px !important;
  }
  .react-datepicker {
    font-size: 0.7em !important;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker-popper {
    width: 330px !important;
    //  transform: translate(50px, 65px) scale(1.3) !important; //for main
    /* transform: ${(props) =>
      props.isPushBotVisible
        ? "none"
        : "translate(50px, 65px) scale(1.3) !important"}; */
  }
  .user-select {
    background-color: #fff;
    border: 1px solid #999999;
    border-radius: 6px;
    width: 100%;
    color: #ccc;
    padding-left: 10px;
    font-size: 14px;
    color: #666666;
    margin-top: 4px;
    outline: none;
  }
  /* @media(max-width : 400px){

    .react-datepicker-popper{
        width:330px !important;
    //  transform: translate(13px, 63px) scale(1.3) !important; //for main
    transform: ${(props) =>
    props.isPushBotVisible
      ? "translate(-37px, 22px) scale(0.9) !important"
      : "translate(13px, 63px) scale(1.3) !important"};
    }
    } */
`;
const ActionButton = styled.div`
  border: 0px solid #2c387a;
  border-radius: 6px;
  background: #2c387a;
  color: #fff;
  margin-top: 12px;
`;

export default class KYCAppointment extends Component {
  state = {
    startDate: "",
    addressType:"Office Address",
    timeSlot:"08:00 AM - 12:00 PM"
  };
  componentDidMount() {
    document.querySelectorAll(".datePickerSubmitButton").forEach((element) => {
      element.classList.add("disabled");
    });
  }
  handleChange = (Tdate) => {
    this.setState({startDate: Tdate,});
    document.querySelectorAll(".datePickerSubmitButton").forEach((element) => {
      element.classList.remove("disabled");
    });
  };
  addressSelection = (e) =>{
      this.setState({addressType:e.target.value});
  }
  timeSlotSelection = (e) =>{
    this.setState({timeSlot:e.target.value});
}
  handleClick = () => {
    let s_date = String(this.state.startDate);

    //0-9 --> adding front zeros
    let month = s_date.substring(4, 7);
    var val = months.indexOf(month) + 1;
    if (val < 10) {
      month = "0" + val;
    } else {
      month = val;
    }
    let selectedDate =s_date.substring(11, 15) +"-" +month +"-" +s_date.substring(8, 10);
    // let UIText =s_date.substring(8, 10) +"-" +month +"-" +s_date.substring(11, 15) +", " +time;
    //2020-07-16T15:09:00
    let dateToBackend = {
        "date": selectedDate,
        "time":this.state.timeSlot,
        "addressType":this.state.addressType
    } 
    // console.log(dateToBackend);
    let inputString = "Continue" + "<split>" + JSON.stringify(dateToBackend);
    window["autosubmit"](inputString);

    document.querySelectorAll(".datePickerSubmitButton").forEach((element) => {
      element.classList.add("disabled");
    });
    document.querySelectorAll(".sf-datepicker").forEach((element) => {
      element.classList.add("disabled");
    });
    document.querySelectorAll(".user-select").forEach((element) => {
      element.classList.add("disabled");
    });
 
  };

  render() {

    return (
      <MainBlock isPushBotVisible={this.props.isPushBotVisible}>
        <div className="datepicker-div">
          <DatePicker
            className="sf-datepicker action-elem"
            selected={this.state.startDate}
            onChange={this.handleChange}
            minDate={new Date(date.getFullYear(), date.getMonth(), (date.getDate()+1))}
            maxDate={new Date(date.getFullYear(), date.getMonth(), (date.getDate()+31))}
            dateFormat="dd-MM-yyyy"
            autoComplete="off"            
            placeholderText="Click to select date"
          />
        </div>
        <select className="user-select action-elem"
        onChange={(ev) => this.timeSlotSelection(ev)} style={{width:"92%"}}>
          <option>08:00 AM - 12:00 PM</option>
          <option>12:00 PM - 04:00 PM</option>
          <option>04:00 PM - 08:00 PM</option>
        </select>
        <select className="user-select action-elem"
        onChange={(ev) => this.addressSelection(ev)} style={{width:"92%"}}>
          <option>Office Address</option>
          <option>Residence Address</option>
        </select>
        <div className="action-elem"
          
            style={{ width: "92%", marginTop: "10px",opacity:this.state.startDate != ""?"1":"0.5",pointerEvents:this.state.startDate != ""?"initial":"none"}}
            onClick={this.handleClick}
          >
            Submit
          
         </div>
      </MainBlock>
    );
  }
}
